import BrokerCreationTemplate from "./BrokerCreationTemplate";
import PersonSelect from "./PersonSelect";
import Disabled from "components/common/Disabled";
import {
  PRODUCER_BROKER_API_NAME,
  useGetSortedBrokerList,
  useGetSortedBrokerListWithRefresh,
} from "components/inputs/program/BrokerSupport";
import * as labels from "config.labels";
import { useSelector, useDispatch } from "react-redux";
import * as staticDataService from "services/staticDataService";
import * as peopleActions from "store/actions/people/peopleActions";
import * as staticDataHooks from "store/hooks/staticDataHooks";
import * as peopleSelectors from "store/selectors/people/peopleSelectors";

const ProducerBrokerCreation = ({ onCreate, onClose }) => {
  const brokers = useGetSortedBrokerList(PRODUCER_BROKER_API_NAME);

  const [createBroker] = staticDataService.useCreateProducerBrokerMutation();

  return (
    <BrokerCreationTemplate
      brokers={brokers}
      createBroker={createBroker}
      visibilityBaseTag={"<ProducerBrokerCreation>"}
      defaultVisibilityOverrideById={{
        name: true,
        email: false,
        workNumber: false,
        mobileNumber: false,
        company: true,
        address: false,
        licenseNumber: true,
        location: false,
      }}
      formId={"producer-broker-creation-form"}
      title={"Add a new producer/Client Executive broker"}
      onCreate={onCreate}
      onClose={onClose}
    />
  );
};

const ProducerBroker = () => {
  const dispatch = useDispatch();

  const broker = useSelector(peopleSelectors.selectProducerBroker);

  const updateBroker = (value) => {
    dispatch(peopleActions.updateProducerBroker(value));
  };

  const [sortedBrokers, refreshBrokers] = useGetSortedBrokerListWithRefresh(
    PRODUCER_BROKER_API_NAME
  );

  const translateLabel = staticDataHooks.useTranslator("uiLabels");

  return (
    <Disabled ifReadOnly>
      <PersonSelect
        person={broker}
        personList={sortedBrokers}
        onUpdatePerson={updateBroker}
        onUpdatePersonList={refreshBrokers}
        PersonCreationComponent={ProducerBrokerCreation}
        label={translateLabel(labels.PRODUCER_BROKER_TITLE, {
          default: "Producer/Client Executive Broker",
        })}
        showLabelOnCard
        showLicenseNumber
        searchProps={{
          showLicenseNumber: true,
        }}
      />
    </Disabled>
  );
};
export default ProducerBroker;
